import AutoComplete from "../Controls/AutoComplete";

export default function FormAutoComplete(props) {
  const label = props.label || props.field;
  const field = props.field || props.label;

  if (!label && !props.hasOwnProperty("label")) {
    console.error("FormAutoComplete requires label property");
  }
  if (!field && props.formObject?.object && !props.formObject.object.hasOwnProperty(field)) {
    console.error("The object specified does not have a " + field + " property");
  }
  if (!props.hasOwnProperty("options")) {
    console.error((props.label || "FormAutoComplete") + " requires options property");
  }
  if (!props.formObject?.hasOwnProperty("onChange")) {
    console.error((props.label || "FormAutoComplete") + " requires onChange property");
  }

  const value =
    props.value !== undefined && props.value !== null
      ? props.value
      : props.formObject?.object?.[field] ?? "";

  return (
    <div
      className={`field FormAutoComplete form-group${props.className ? ` ${props.className}` : ""}`}
    >
      <AutoComplete
        id={field + "Select"}
        label={label}
        value={value}
        options={props.options || []}
        placeholder={props.placeholder}
        onChange={(e, v) => {
          props.formObject?.onChange?.(v, field, "AutoComplete", e);
        }}
        onSelect={(v) => {
          props.formObject?.onChange?.(v, field, "AutoComplete");
        }}
      />
    </div>
  );
}
